module.exports = __webpack_public_path__ + "img/bg_bendi_home.7e819481.png";